import { render } from "./radioAndLabel.vue?vue&type=template&id=e03bedd2&scoped=true"
import script from "./radioAndLabel.vue?vue&type=script&lang=js"
export * from "./radioAndLabel.vue?vue&type=script&lang=js"

import "./radioAndLabel.vue?vue&type=style&index=0&id=e03bedd2&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e03bedd2"]])

export default __exports__